import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { motion as m, AnimatePresence } from "framer-motion";

const MainLayout = ({ children, showSidebar = true }) => {
  const [isSidebarVisible, setSidebarVisible] = useState(
    sessionStorage.getItem("sidebarVisible") === "true"
  );

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
    sessionStorage.setItem("sidebarVisible", !isSidebarVisible);
  };

  return (
    <div>
      <Header toggleSidebar={toggleSidebar} />
      <div className="flex w-full h-[calc(100vh-80px)]">
        <AnimatePresence>
          {isSidebarVisible && (
            <m.div
                className="fixed top-[80px] left-0 right-0 bottom-0 z-[999] xl:relative xl:top-0 xl:inset-auto xl:z-0 bg-black/30 xl:bg-transparent"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={toggleSidebar}
            >
              <m.div
                className="h-full w-fit"
                initial={{ x: -320 }}
                animate={{ x: 0 }}
                exit={{ x: -320 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Sidebar
                  hideSidebarOnclick={() => {
                    setSidebarVisible(false);
                  }}
                />
              </m.div>
            </m.div>
          )}
        </AnimatePresence>
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
